<app-dialog-base>
  <span dialog-title>{{ data.title }}</span>
  <ng-container dialog-content>
    <p data-testid="confirm-rule-date-question">{{ data.question }}</p>
  </ng-container>
  <ng-container actions>
    <button mat-button class="primary-button" data-testid="confirm-rule-date-button" (click)="confirm()">Save</button>
  </ng-container>
</app-dialog-base>
